module.exports = __webpack_public_path__ + "img/agence-07.b91dbd1.jpg";